import { AfterViewInit, Component } from '@angular/core';
import { FspOwnersGridDataService } from './fsp-owners-grid-data.service';
import {
  getFspOwnersGridToolbarItems,
  fspOwnersGridColumns,
} from './fsp-owners-grid-model';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { filter, takeWhile, tap } from 'rxjs';
import { FreeServicesParcelRequestGridDataService } from '../fsp-parcel-request-grid/free-services-parcel-request-grid-data.service';
import { FreeServicesParcelRequestGridDto } from '../fsp-parcel-request-grid/free-services-parcel-request-grid-data-model';
import { WladajacyResponseDto } from '../../../gk-map/models';
import { GkKendoGridComponent } from '../../../gk-kendo';
import { FreeServicesRequestListGridDataService } from '../../free-services-request-list-grid/free-services-request-list-grid-data.service';
import { FreeServicesRequestListGridDto } from '../../free-services-request-list-grid/free-services-request-list-grid-data-model';

@Component({
  selector: 'app-fsp-owners-grid',
  templateUrl: '../../../gk-kendo/gk-kendo-grid/gk-kendo-grid.component.html',
  standalone: false,
})
export class FspOwnersGridComponent
  extends GkKendoGridComponent<WladajacyResponseDto>
  implements AfterViewInit
{
  constructor(
    public fspOwnersGridDataService: FspOwnersGridDataService,
    public freeServicesParcelRequestGridDataService: FreeServicesParcelRequestGridDataService,
    public freeServicesRequestListGridDataService: FreeServicesRequestListGridDataService,
  ) {
    super(fspOwnersGridDataService);
  }

  override topGridToolbarItems = getFspOwnersGridToolbarItems();
  override columns = fspOwnersGridColumns;
  override selectable: SelectableSettings = {
    enabled: true,
    mode: 'single',
  };
  override sortable = true;
  selectedParcelGridItem: FreeServicesParcelRequestGridDto;
  selectedRequestListGridItem: FreeServicesRequestListGridDto;

  override ngAfterViewInit(): void {
    this.subscribeToParcelListGridSelectedKeys();
    this.subscribeToRequestListGridSelectedKeys();
  }

  subscribeToParcelListGridSelectedKeys(): void {
    this.freeServicesParcelRequestGridDataService.$selection
      .pipe(
        takeWhile(() => this.isAlive),
        tap(() => {
          this.selectedParcelGridItem = undefined;
          this.fspOwnersGridDataService.clearGridData();
        }),
        filter(Boolean),
      )
      .subscribe((selection) => {
        this.selectedParcelGridItem = selection.selectedRows[0].dataItem;
        this.fetchGridData();
      });
  }

  subscribeToRequestListGridSelectedKeys(): void {
    this.freeServicesRequestListGridDataService.$selection
      .pipe(
        takeWhile(() => this.isAlive),
        tap(() => {
          this.selectedRequestListGridItem = undefined;
        }),
        filter(Boolean),
      )
      .subscribe((selection) => {
        this.selectedRequestListGridItem = selection.selectedRows[0].dataItem;
      });
  }

  fetchGridData(): void {
    this.fspOwnersGridDataService.$loading.next(true);
    this.freeServicesParcelRequestGridDataService
      .fetchParcelDetailsFromApi(
        this.selectedRequestListGridItem.ZamowUuid,
        this.selectedParcelGridItem.KdzialkaUuid,
      )
      .subscribe((data) => {
        this.fspOwnersGridDataService.$loading.next(false);
        this.fspOwnersGridDataService.next({
          data: data.Wladajacy,
          total: data.Wladajacy.length,
        });
      });
  }
}
